import { useIntl } from "react-intl";
import { WmActionMenu, WmMenuitem } from "@watermarkinsights/ripple-react";
import { buildSvgIconHref } from "../ai-chat-message-utils";

interface DownloadActionMenuProps {
  tooltip: string;
  onDownloadPng: () => void;
  onDownloadCsv?: () => void;
  disabled?: boolean;
}

export const DownloadActionMenu = ({
  tooltip,
  onDownloadPng,
  onDownloadCsv,
  disabled = false,
}: DownloadActionMenuProps) => {
  const intl = useIntl();

  return (
    <WmActionMenu
      action-menu-type="icon"
      icon="#download"
      icon-size="1.125rem"
      className="tcw-export-exclude"
      tooltip={tooltip}
      disabled={disabled}
    >
      <WmMenuitem icon={buildSvgIconHref("download-png")} icon-size="1.125rem" onClick={onDownloadPng}>
        {intl.formatMessage({ id: "app.toolboxChat.action.downloadPng" })}
      </WmMenuitem>
      <WmMenuitem
        icon={buildSvgIconHref("export-csv")}
        icon-size="1.125rem"
        disabled={!onDownloadCsv}
        onClick={onDownloadCsv}
      >
        {intl.formatMessage({ id: "app.toolboxChat.action.exportCsv" })}
      </WmMenuitem>
    </WmActionMenu>
  );
};
